import Page from '../page';
import PatheSlider from '../../helpers/patheSlider'

export default class PatheIndex extends Page {
    constructor(...args) {
        super(...args);

        // dont works
        let patheSliderPart = this.dom.component.querySelector('.pathe-slider')
        this.sliderHelper = new PatheSlider(patheSliderPart || this.dom.component)
    }

    bind(){
        super.bind();
        this.sliderHelper.bind()
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}


// WEBPACK FOOTER //
// src/js/pages/pathe/pathe.js